import { render, staticRenderFns } from "./ChargebackAuditLogs.vue?vue&type=template&id=2604f082&"
import script from "./ChargebackAuditLogs.vue?vue&type=script&lang=js&"
export * from "./ChargebackAuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./ChargebackAuditLogs.vue?vue&type=style&index=0&id=2604f082&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports